import React, { useState } from 'react';
import {
	SdfBadge,
	SdfButton,
	SdfIcon,
	SdfTooltip
} from '@synerg/react-components';
import { EditPartnerProject } from './editPartnerProject';
import { updateCurrentProjectDetails, useApplicationState } from '../../../utilities/applicationState';
import DeleteProject from './deleteProject.jsx';

export const ProjectTitle = (props = {}) => {
	const { projectDetails, projectListData, handleResponse } = props;
	const [store, dispatch] = useApplicationState();
	const { projects: {current : {deleteModal = false}} } = store;
	const [showEditModal, setShowEditModal] = useState(false);

	const STATE = {
		"Not Started": 'failed',
		"Not Assigned": 'failed',
		"In Progress": 'in-progress',
		"Pre Launch": 'new',
		Live: 'complete',
		Legacy: 'default'
	};

	return (
		<div className="inline-flex w-full">
			<div className="flex-1">
				<div className="text-heading-07 font-black inline pr-2">
					{projectDetails.name}
				</div>
				<SdfTooltip data-cvs-id="1899" state="neutral">
					<SdfIcon
						data-cvs-id="1900"
						class="text-alert-neutral text-xl"
						slot="tooltip-target"
						icon="alert-info"
					/>
					<div data-cvs-id="1901">{projectDetails.description}</div>
				</SdfTooltip>
				<SdfButton
					className="p-5 text-xl"
					action="standard"
					emphasis="tertiary"
					variant="text"
					icon={"action-edit"}
					onClick={() => setShowEditModal(true)}
				>
					<span className="text-md font-medium"> &nbsp;Edit</span>
				</SdfButton>
				<SdfBadge status={STATE[projectListData.status]}>
					{projectListData.status}
				</SdfBadge>
			</div>
			<div>
				<SdfButton
					action="destructive"
					emphasis="primary"
					size="sm"
					variant="contained"
					{...( !((projectListData.legacy) || (projectListData.type === 'DEV' && !projectListData.link)) && {disabled: true}  ) }
					onClick={() => dispatch(updateCurrentProjectDetails({deleteModal: true}))}

				>
					Delete project
				</SdfButton>
			</div>
			{deleteModal && <DeleteProject onHide={() => dispatch(updateCurrentProjectDetails({deleteModal: false}))} project={projectListData} />}

			{showEditModal ? (
				<EditPartnerProject
					projectDetail={projectDetails}
					showEditModal={showEditModal}
					setShowEditModal={setShowEditModal}
					handleResponse={handleResponse}
				/>
			) : null}
		</div>
	);
};
